import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Banner from '../views/Banner';

import { WIDGET_STATE } from '../constants/app';
import { WIDGET, HEADER } from '../constants/dimensions';
import { CONNECTION_STATE } from '../constants/connection-state';
import { reconnectFaye } from '../actions/faye';

const bannerStyles = { position: 'absolute', left: '10px', top: `${9 + HEADER.HEIGHT}px` };

function getBannerText(
    connectionState,
    couldNotConnectText,
    couldNotConnectInnerText,
    couldNotConnectWithRetryText,
    couldNotConnectWithRetryInnerText,
) {
    let retryTextToUse;
    let bannerTextToUse;

    switch (connectionState) {
        case CONNECTION_STATE.DISCONNECTED:
            bannerTextToUse = couldNotConnectText;
            retryTextToUse = couldNotConnectInnerText;
            break;
        // if connection state is connected but onLine is false, keep showing the banner
        case CONNECTION_STATE.CONNECTED:
        case CONNECTION_STATE.DISCONNECTED_WITH_RETRY:
            bannerTextToUse = couldNotConnectWithRetryText;
            retryTextToUse = couldNotConnectWithRetryInnerText;
            break;
        default:
            bannerTextToUse = '';
            retryTextToUse = '';
    }

    const retryStringReplace = '{retry}';
    const textFirstPart = bannerTextToUse.substring(0, bannerTextToUse.indexOf(retryStringReplace));
    const textLastPart = bannerTextToUse.substring(
        bannerTextToUse.indexOf(retryStringReplace) + retryStringReplace.length,
    );

    return { textFirstPart, textLastPart, retryTextToUse };
}

function getStyles(widgetSize, widgetState) {
    const styles = {
        fixedContainer: {
            zIndex: 2,
            position: 'fixed',
            width: WIDGET[`WIDTH_${widgetSize.toUpperCase()}`],
        },
        embeddedModeContainer: {
            zIndex: 2,
        },
        retryButton: {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    };

    return widgetState === WIDGET_STATE.EMBEDDED ? styles.embeddedModeContainer : styles.fixedContainer;
}

class ConnectionErrorBanner extends React.Component {
    static propTypes = {
        appUserId: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
        widgetSize: PropTypes.string.isRequired,
        widgetState: PropTypes.symbol.isRequired,
        connectionState: PropTypes.symbol.isRequired,
        couldNotConnectText: PropTypes.string.isRequired,
        couldNotConnectInnerText: PropTypes.string.isRequired,
        couldNotConnectWithRetryText: PropTypes.string.isRequired,
        couldNotConnectWithRetryInnerText: PropTypes.string.isRequired,
    };

    onActionTextClick = () => {
        reconnectFaye();
    };

    render() {
        const {
            appUserId,
            connectionState,
            widgetSize,
            widgetState,
            couldNotConnectText,
            couldNotConnectInnerText,
            couldNotConnectWithRetryText,
            couldNotConnectWithRetryInnerText,
        } = this.props;
        // A navigator.onLine value of undefined means the browser lacks support
        // In this case we assume internet connectivity
        const noInternet = navigator.onLine === false;
        const isConnected = connectionState === CONNECTION_STATE.CONNECTED;
        const showBanner = noInternet || (appUserId && !isConnected);

        const { textFirstPart, textLastPart, retryTextToUse } = getBannerText(
            connectionState,
            couldNotConnectText,
            couldNotConnectInnerText,
            couldNotConnectWithRetryText,
            couldNotConnectWithRetryInnerText,
        );

        return (
            <div style={getStyles(widgetSize, widgetState)}>
                <Banner styles={{ ...bannerStyles, opacity: showBanner ? 1 : 0 }}>
                    {textFirstPart}
                    <Banner.ActionText onClick={this.onActionTextClick}>{retryTextToUse}</Banner.ActionText>
                    {textLastPart}
                </Banner>
            </div>
        );
    }
}

export default connect(
    ({ appState: { connectionState, widgetSize, widgetState }, ui: { text }, user: { _id: appUserId } }) => {
        return {
            widgetSize,
            widgetState,
            appUserId,
            connectionState: connectionState,
            couldNotConnectText: text.couldNotConnect,
            couldNotConnectInnerText: text.couldNotConnectInner,
            couldNotConnectWithRetryText: text.couldNotConnectWithRetry,
            couldNotConnectWithRetryInnerText: text.couldNotConnectWithRetryInner,
        };
    },
    undefined,
    undefined,
    {
        forwardRef: true,
    },
)(ConnectionErrorBanner);
